import Quill from 'quill'

let registered = false

/**
 * 注册块级 text-indent（2em）格式，需在首个 Quill 实例创建前调用一次。
 */
export function registerQuillFirstLineIndent () {
  if (registered) return
  registered = true
  const Parchment = Quill.import('parchment')
  const TextIndentStyle = new Parchment.Attributor.Style('textIndent', 'text-indent', {
    scope: Parchment.Scope.BLOCK,
    whitelist: ['2em']
  })
  Quill.register(TextIndentStyle, true)

  // Snow 主题只对 icons 里声明的按钮注入 SVG；否则按钮为空且看不到「图标」
  const icons = Quill.import('ui/icons')
  if (icons && icons.firstLineIndent == null) {
    icons.firstLineIndent =
      '<svg viewbox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">' +
      '<title>首行缩进</title>' +
      '<line class="ql-stroke" x1="8" x2="15" y1="4" y2="4"></line>' +
      '<line class="ql-stroke" x1="3" x2="15" y1="9" y2="9"></line>' +
      '<line class="ql-stroke" x1="3" x2="15" y1="14" y2="14"></line>' +
      '</svg>'
  }
}

/**
 * Snow 工具栏自定义按钮的 handler；由 Toolbar 以 (value) 调用，value 为 false 表示取消缩进。
 */
export function firstLineIndentToolbarHandler (value) {
  const quill = this.quill
  quill.focus()
  const range = quill.getSelection()
  if (!range) return
  quill.format('textIndent', value ? '2em' : false, Quill.sources.USER)
}
